<template>
	<div data-tour-scope="communications-list">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.communications') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- <v-divider vertical></v-divider>-->
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="3">
									<v-text-field
										v-model="searchfield"
										label="Cerca cliente, email, telefono, ordine o oggetto"
										outlined
										append-icon="mdi-magnify"
										dense
										clearable
										hide-details
										@input="searchit"
										@click:append="getSearch()"
										@keyup.enter="getSearch()"
										@click:clear="svuotaRicerca"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="3">
									<v-menu v-model="dataordine" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
										<template v-slot:activator="{ on }">
											<v-text-field :value="computedDatejs" v-on="on" outlined dense clearable @click:clear="cleardate" label="Data messaggio" hide-details> </v-text-field>
										</template>
										<v-date-picker v-model="dateScelte" range locale="it" first-day-of-week="1" @change="impostaDate"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-model="settings.filters.owner"
										item-text="name"
										item-value="value"
										:items="[
											{ name: 'Cliente', value: 'Customer' },
											{ name: 'Negozio', value: 'Store' },
										]"
										outlined
										dense
										label="Mittente"
										hide-details
										clearable
									></v-select>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							v-model="selectedall"
							:headers="headers"
							:items="getOrders"
							:options.sync="settings.options"
							:server-items-length="total"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:mobile="isMobile"
							@input="toggle"
							:mobile-breakpoint="0"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="communication-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.subject || 'Messaggio'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-btn v-if="item.order && item.order._id" small icon color="primary" data-tour="order" title="Apri ordine" @click="editItem(item)">
														<v-icon>mdi-magnify</v-icon>
													</v-btn>
													<v-btn small icon color="primary" data-tour="expand" :title="checkpresenza(item._id) ? 'Chiudi' : 'Mostra messaggio'" @click="extension(item._id)">
														<v-icon>{{ checkpresenza(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<template v-slot:top>
													<div v-if="!checkpresenza(item._id) && anteprima(item)" class="cm-preview mb-2">{{ anteprima(item) }}</div>
												</template>
												<CommunicationConversation v-if="checkpresenza(item._id)" :item="item" @open-order="editItem(item)" />
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun messaggio</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr :key="item._id" class="cm-list-row" :class="{ 'cm-list-row--open': checkpresenza(item._id) }" @click="extension(item._id)">
											<td class="pr-0" style="width: 40px">
												<v-btn small icon data-tour="expand" :title="checkpresenza(item._id) ? 'Chiudi' : 'Mostra conversazione'" @click.stop="extension(item._id)">
													<v-icon>{{ checkpresenza(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td class="cm-nowrap">
												<div>{{ item.created_at | moment('DD/MM/YYYY') }}</div>
												<div class="cm-sub">{{ item.created_at | moment('HH:mm') }}</div>
											</td>
											<td>
												<div class="font-weight-medium">{{ nomeCliente(item) || '—' }}</div>
												<div class="cm-sub">{{ contattiCliente(item) }}</div>
											</td>
											<td class="cm-nowrap">
												<v-chip v-if="item.order && item.order._id" small outlined color="primary" data-tour="order" title="Apri ordine" @click.stop="editItem(item)">
													<v-icon left x-small>mdi-magnify</v-icon>{{ item.order.OrderId }}
												</v-chip>
												<span v-else-if="item.order && item.order.OrderId">{{ item.order.OrderId }}</span>
												<span v-else class="cm-sub">—</span>
											</td>
											<td>
												<v-chip x-small :color="item.owner === 'Store' ? 'primary' : undefined" :outlined="item.owner !== 'Store'">{{ item.owner === 'Store' ? 'Negozio' : 'Cliente' }}</v-chip>
											</td>
											<td class="cm-subject-cell">
												<div class="cm-subject-line">{{ item.subject || '(senza oggetto)' }}</div>
												<div class="cm-sub cm-subject-line">{{ anteprima(item) }}</div>
											</td>
											<td class="cm-nowrap">
												<span v-if="(item.attachments || []).length" class="cm-sub"><v-icon small>mdi-paperclip</v-icon>{{ item.attachments.length }}</span>
											</td>
											<td class="cm-sub">{{ (item.user && item.user.name) || '' }}</td>
										</tr>
										<tr v-if="checkpresenza(item._id)" :key="item._id + '-thread'" class="cm-expanded">
											<td colspan="8" class="py-3">
												<CommunicationConversation :item="item" @open-order="editItem(item)" />
											</td>
										</tr>
									</template>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun messaggio con questi filtri</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Seri sicuro?</v-card-title>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="secondary" @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createCommunicationsTourSteps } from './communications-tour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { anteprimaEmail, testoDaEntita } from '@/utils/emailHtml';
import CommunicationConversation from '@/components/communication/CommunicationConversation.vue';
import { openWithReturn } from '@/components/core/pageReturn';


export default {
	name: 'Order',
	setup() {
		return { tour: useTour(createCommunicationsTourSteps()) };
	},
	data() {
		return {
			menu: false,
			// date cliccate nel calendario: diventano filtro solo a intervallo completo (impostaDate)
			dateScelte: [],
			loadingDownload: false,
			errorDownloadReview: '',
			modalDownloadReview: false,

			idStart: '',
			idEnd: '',
			componentKey: 0,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					preparation_date: [],
					payments: [],
					agents: [],
					color: [],
					owner: '',
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},

			listSize: [15, 25, 50, 100],
			linkdownload: '',
			searchfield: '',
			selected: [],
			selectedchecbox: [],
			selectedall: [],
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: '', value: '' },
				{ text: 'Data', value: 'created_at' },
				{ text: 'Cliente', value: 'buyer', sortable: false },
				{ text: 'Ordine', value: 'order', sortable: false },
				{ text: 'Mittente', value: 'owner' },
				{ text: 'Oggetto', value: 'subject' },
				{ text: 'Allegati', value: 'attachments', sortable: false },
				{ text: 'Operatore', value: 'user', sortable: false },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			isMobile: true,
			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			parseDate: [],
			dataordine: '',
			datapreparazione: '',
			platform: [],
			packagings: [],
			status: [],
			payments: [],
			agents: [],
			choosePlaform: [],
			chooseStatus: [],
			choosePayments: [],
			Totale: 0,
			Fee: 0,
			Refund: 0,
			Gain: 0,
			page: 1,

			//Invoice Fattureincloud
			TypeInvoice: '',
			InvoiceItem: '',
			magento: false,
			shopify: false,
			prestashop: false,
			woocommerce: false,
			fattureincloud: false,
			dialogOrderSupplier: false,
			idsOrderSupplier: [],
			singleOrderSupplier: false,
			dateOrderSupplier: '',
			checkInPreparazione: true,
			checkRollbackInPreparazione: false,
			operation: '',
			dialogPrint: false,
			dialogPrintMultiple: false,
			users: [],
			user_selected: null,
			courier_selected: null,
			order_to_print: null,
			orders_to_print: null,
			status_elaboration: null,
			selectColor: ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'],
		};
	},

	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},

	created() {},
	async mounted() {
		const today = new Date();
		const oldtoday = new Date();
		oldtoday.setMonth(oldtoday.getMonth() - 1);
		this.settings.filters.created_at = [
			`${oldtoday.getFullYear()}-${(oldtoday.getMonth() + 1).toString().padStart(2, '0')}-${oldtoday.getDate().toString().padStart(2, '0')}`,
			`${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`,
		];
		this.dateScelte = [...this.settings.filters.created_at];
		this.setDialog(false);
		this.setExistFilter(true);

		let promises = [];
		promises.push(this.fetchSetting());

		promises.push(this.fetchServiceactive(['imap']));

		const result = await Promise.all(promises);
		const status = result[1];
	},
	watch: {
		selectedLength(val) {
			if (val > 0) {
				//_.set(this.selectedall,'[0]',1)
				//_.assign(this.selectedall[0],1)
				this.selectedall = [-1];
			}
		},
		selectedchecbox() {
			if (this.selectedchecbox.length === 1) {
				let el = this.selectedchecbox[0];
				let item = _.find(this.getOrders, i => {
					return i._id === el;
				});
				if (item) {
					if (item.Invoice && item.Invoice.Number) {
						if (item.Invoice.Name === 'Ricevuta') {
							this.TypeInvoice = 'Ricevuta';
						}
						if (item.Invoice.Name === 'Fattura') {
							this.TypeInvoice = 'Fattura';
						}
						this.InvoiceItem = true;
					} else {
						this.InvoiceItem = false;
					}

					if (item.Status === 'In Preparazione') {
						this.checkInPreparazione = false;
						this.checkRollbackInPreparazione = true;
					}
				}
			} else {
				this.checkInPreparazione = true;

				_.forEach(this.selectedchecbox, ord => {
					let item = _.find(this.getOrders, i => {
						return i._id === ord;
					});
					if (item) {
						if (item.Status === 'In Preparazione') {
							this.checkInPreparazione = false;
							this.checkRollbackInPreparazione = true;
						}
					}
				});
			}
		},
		'settings.options': {
			handler: function (val) {
				if (_.isUndefined(this.settings.options.sortBy[0]) && this.settings.options.sortBy[0] !== '') {
					let outcome = this.getSortDesc;
					outcome = !outcome;
					this.settings.options.sortBy = [];
					this.settings.options.sortDesc = [];
					this.settings.options.sortBy.push(this.getSortBy);
					this.settings.options.sortDesc.push(outcome);
				}
				if (val.page === this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.page;

				this.getDataFromApi();
			},
			deep: true,
		},
		'settings.filters': {
			handler: function () {
				this.settings.options.page = 1;
				this.getDataFromApi();
			},
			deep: true,
		},
	},
	components: {
		CommunicationConversation,
		TourOverlay,
		KeyValueCard,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		selectedLength() {
			return this.selectedchecbox.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getOrders: 'communications/getItems',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'communications/getIndex',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'communications/getSortBy',
			getSortDesc: 'communications/getSortDesc',
			getLanguage: 'profile/getLanguage',
			getUsers: 'users/getUsers',
			getSetting: 'settings/getSetting',
			getRole: 'profile/getRole',
		}),
		/*Totale(){
                console.log(filteredItems)
                /!*if(filteredItems.length>0) {
                    return filteredItems.reduce((total, current) => {
                        return total + parseFloat(current.Total)
                    })

                }*!/
            },*/
		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		filteredItems() {
			let filters = this.getOrders;

			filters = filters.filter(d => {
				//console.log("fine",moment(this.parseDate[1]+" 23:59:59").utc().format());
				if (this.parseDate.length === 1) {
					return (
						d.created_at >
						moment(this.parseDate[0] + ' 00:00:00')
							.utc()
							.format()
					);
				}
				if (this.parseDate.length === 2) {
					return (
						d.created_at >
							moment(this.parseDate[0] + ' 00:00:00')
								.utc()
								.format() &&
						d.created_at <
							moment(this.parseDate[1] + ' 23:59:59')
								.utc()
								.format()
					);
				}
				return d;
			});

			filters = filters.filter(d => {
				if (this.choosePlaform.length > 0) {
					return this.choosePlaform.includes(d.Platform);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.chooseStatus.length > 0) {
					return this.chooseStatus.includes(d.Status);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.choosePayments.length > 0) {
					return this.choosePayments.includes(d.Checkout.PaymentMethods);
				}
				return d;
			});

			let sum;
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Total, 0);

				this.Totale = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Refund, 0);

				this.Refund = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				let total = 0;
				let refund = 0;
				filters.forEach(value => {
					if (value.Buy) {
						total += this.scorporoiva(value.Total, value.BuyVat) - value.Buy - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
					if (value.Refund) {
						refund += value.Total - value.Refund - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
				});
				this.Gain = parseFloat(total + refund, 2).toFixed(2);
			}
			return filters;
		},
		computedDatejs() {
			let arrayDate = [];
			if (this.settings.filters.created_at.length > 0) {
				this.settings.filters.created_at.forEach(value => {
					// console.log(value)
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
		computedDatePrepjs() {
			let arrayDate = [];
			if (this.settings.filters.preparation_date.length > 0) {
				this.settings.filters.preparation_date.forEach(value => {
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
	},

	methods: {
		// coppie chiave/valore della card da telefono
		campiCard(item) {
			return [
				{ label: 'Data', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY HH:mm') : '' },
				{ label: 'Cliente', value: this.nomeCliente(item) || (item.buyer && item.buyer.email), strong: true },
				{ label: 'Ordine', value: item?.order?.OrderId },
				{ label: 'Mittente', value: item.owner === 'Store' ? 'Negozio' : 'Cliente' },
				{ label: 'Allegati', value: (item.attachments || []).length || '' },
			];
		},
		nomeCliente(item) {
			const b = item.buyer || {};
			return testoDaEntita([b.name, b.lastname].filter(Boolean).join(' '));
		},
		contattiCliente(item) {
			const b = item.buyer || {};
			return [b.email, b.phone].filter(Boolean).join(' · ');
		},
		// anteprima in testo semplice, calcolata una volta per messaggio (DOMParser non e' gratis)
		anteprima(item) {
			if (!this.anteprime) this.anteprime = {};
			if (!(item._id in this.anteprime)) this.anteprime[item._id] = anteprimaEmail(item.text, 160);
			return this.anteprime[item._id];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setOrders: 'communications/setOrders',
			setOrder: 'orders/setOrder',
			setIndex: 'communications/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
			setSnackbarApp: 'settings/setSnackbar',
			setPackingList: 'packingLists/setPackingList',
		}),
		...mapActions({
			fetchOrder: 'orders/edit',
			fetchOrders: 'communications/asyncFetchData',
			fetchReports: 'communications/asyncFetchReportData',
			destroyData: 'communications/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			createSupplierOrders: 'communications/createSupplierOrders',
			fetchStatusOrder: 'statusorders/fetchLists',
			fetchPaymentMethod: 'paymentmethods/fetchLists',
			fetchAgentMethod: 'agents/fetchLists',
			updateEnableAgents: 'communications/updateEnableAgents',
			getOrdersReview: 'communications/getOrdersReview',
			fetchPackagings: 'packagings/getListings',
			fetchUsers: 'users/asyncFetchUsers',
			fetchServiceactive: 'services/getServiceFetchActive',
		}),
		convertSearch(match) {
			let result = match;

			if (this.settings?.search && result) {
				var re = new RegExp(this.settings.search, 'gi');
				result = match.replace(re, `<mark>${this.settings.search}</mark>`);
			}
			return result;
		},

		convertDataForRange() {
			let stringaData = '';
			const listDate = [];
			const replace = JSON.parse(JSON.stringify(this.settings.filters.created_at));
			if (replace.length > 0) {
				for (let d of replace) {
					const datareplace = new Date(e);
					listDate.push(`${datareplace.getDate()}/${datareplace.getMonth()}/${datareplace.getFullYear()}`);
				}
			}
			if (listDate.length > 0) {
				return listDate.join(' ~ ');
			} else {
				return '';
			}
		},

		async propSetMessages(text) {
			if (text != 'refresh') {
				this.snackbar.color = 'success';
				this.snackbar.text = text;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
			}
			await this.getDataFromApi();
			this.$forceUpdate();
			this.selectedchecbox = [];
			this.operation = '';
		},
		async creaOrdineFornitore(item) {
			this.dialogOrderSupplier = true;
			if (item) {
				this.singleOrderSupplier = true;
				this.idsOrderSupplier = [item._id];
			} else {
				this.singleOrderSupplier = false;
				this.idsOrderSupplier = [];
			}
		},
		async inviaOrdineFornitore() {
			this.dialogOrderSupplier = false;
			this.preload = true;
			this.setPreload(true);
			let orders_id = this.singleOrderSupplier ? this.idsOrderSupplier : this.selectedchecbox;
			let payload = { order_date: this.dateOrderSupplier, order_ids: orders_id };
			let response = await this.createSupplierOrders(payload);

			this.idsOrderSupplier = [];
			this.singleOrderSupplier = false;

			if (response.result === true && response.all_transformed) {
				await this.fetchOrders(this.settings);
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con  successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
				this.setPreload(false);
			} else if (response.result === true && !response.all_transformed) {
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con successo, ma alcuni prodotti non hanno un fornitore associato';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
				this.setPreload(false);
			} else {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore durante invio in preparazione: ' + response.message;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 10000;
				this.preload = false;
				this.setPreload(false);
			}
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'FormCreate';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		changePackaging(pack, item) {
			let url = 'orders/updatepackaging';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, Packaging: pack.value }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					item.Packaging = pack.value;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		changePackagingDelete(item) {
			let url = 'orders/updatepackaging';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, Packaging: {} }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					item.Packaging = {};
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		changeStatus(item, color) {
			let url = 'orders/updatestatus';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, color: color }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], { Color: color });
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selectedchecbox = [];
			} else {
				if (event[0] !== -1) {
					this.selectedchecbox = [];
					_.forEach(this.getOrders, cat => {
						this.selectedchecbox.push(cat._id);
					});
				}
			}
		},
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},
		copy(field) {
			let input = document.createElement('input');
			input.setAttribute('value', field);
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
		},
		scorporoiva(totale, iva) {
			let sc = 0;
			if (!iva || iva === 0) {
				iva = 22;
				iva = iva / 100;
				iva += 1;

				sc = parseFloat(totale / iva).toFixed(2);
			} else {
				sc = totale;
			}
			return sc;
		},
		impostaDate(date) {
			this.settings.filters.created_at = [...(date || [])].sort();
			this.dateScelte = [...this.settings.filters.created_at];
			this.dataordine = false;
		},
		cleardate() {
			this.parseDate = [];
			this.dateScelte = [];
			this.settings.filters.created_at = [];
		},
		cleardatePrep() {
			this.parseDate = [];
			this.settings.filters.preparation_date = [];
		},
		async importItemFromShopify() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'ImportShopify';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async importItemsFromShopify() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'ImportsShopify';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		editItem(item) {
			// l'ordine si apre come pagina; Annulla/Salva tornano qui
			openWithReturn(this, { path: `/orders/${item.order._id}` }, { label: 'Torna alle comunicazioni' });
		},
		async summaryItem(key) {
			this.componentKey += 1;
			let item;

			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			this.setClearError({});

			this.operation = 'FormSummary';
			this.setIndex(this.getOrders.indexOf(item));
			this.setOrder(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async packingListItem(key) {
			this.componentKey += 1;
			let item;

			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			this.setClearError({});

			this.operation = 'FormPackingList';
			this.setIndex(this.getOrders.indexOf(item));
			this.setPackingList({ _id: item.id_packing_list[0]._id });
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async trackingItem(key) {
			this.componentKey += 1;
			let item;

			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			this.setClearError({});

			this.operation = 'FormTracking';
			this.setIndex(this.getOrders.indexOf(item));
			this.setOrder(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		// ricerca da almeno 3 caratteri (come il backend); sotto, nessun filtro di testo
		getSearch() {
			const testo = String(this.searchfield || '').trim();
			const nuova = testo.length >= 3 ? testo : '';
			if (nuova === this.settings.search) return;
			this.settings.search = nuova;
			// a pagina 1 il watcher di options non scatta: si ricarica qui, altrimenti ci pensa lui
			if (this.settings.options.page === 1) this.getDataFromApi();
			else this.settings.options.page = 1;
		},
		svuotaRicerca() {
			this.searchfield = '';
			this.getSearch();
		},
		async duplicateItem(key) {
			this.componentKey += 1;
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			this.setClearError({});

			this.operation = 'FormDuplicate';
			this.setIndex(this.getOrders.indexOf(item));
			this.setOrder(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		toggleClass(num) {
			if (num === 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},
		resetForm() {
			this.form._id = '';
			this.form.name = '';
			this.form.email = '';
			this.form.password = '';
			this.form.action = '';
		},

		searchit: _.debounce(function () {
			this.getSearch();
		}, 600),

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				//const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;
				const result = await this.fetchOrders(this.settings);
				if (result && result.stale) return; // risposta superata da una richiesta piu' recente
				this.setPreload(false);
				if (!result) return; // errore di rete: resta la pagina precedente
				this.total = result.total;
				/*let reports =  this.fetchReports(this.settings).then(result =>{
                        //console.log(result.data.data)
                        if(result.data.data) {
                            this.Totale = result.data.data.total;
                            this.Fee = result.data.data.TotalFee;
                            this.Refund = result.data.data.refund;
                            this.Gain = result.data.data.gain;
                        }


                    });*/
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.componentKey += 1;

			this.setClearError({});

			this.operation = 'FormCreate';
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		printOrderMultiple() {
			let url = 'orders/print-multiple';
			this.preload = true;

			axios
				.post(
					`${this.getUrl}${url}`,
					{
						_ids: this.orders_to_print,
						worker: this.user_selected,
						preview_courier: this.courier_selected,
						printed: true,
						status: this.status_elaboration,
					},
					{ headers: { Authorization: `Bearer ${this.getToken}` } },
				)
				.then(() => {
					this.preload = false;
					this.dialogPrintMultiple = false;
					let split = this.orders_to_print.split(',');
					for (let o of this.getOrders) {
						if (split.includes(o._id)) {
							o.worker = this.user_selected;
							o.preview_courier = this.courier_selected;
							o.printed = true;
							o.StatusOrder = this.status_elaboration;
						}
					}

					let route = this.$router.resolve({ path: '/orders/multiple-print/' + this.orders_to_print });
					window.open(route.href, '_blank');
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		openReceipt(item) {
			let route = this.$router.resolve({ path: '/orders/receipt/' + item._id });
			window.open(route.href, '_blank');
		},

		printOrder() {
			let url = 'orders/update-details';
			this.preload = true;

			axios
				.post(
					`${this.getUrl}${url}`,
					{
						_id: this.order_to_print._id,
						worker: this.user_selected,
						preview_courier: this.courier_selected,
						printed: true,
						status: this.status_elaboration,
					},
					{ headers: { Authorization: `Bearer ${this.getToken}` } },
				)
				.then(() => {
					this.preload = false;

					this.dialogPrint = false;
					this.order_to_print.worker = this.user_selected;
					this.order_to_print.preview_courier = this.courier_selected;
					this.order_to_print.printed = true;
					this.order_to_print.StatusOrder = this.status_elaboration;

					let route = this.$router.resolve({ path: '/orders/print/' + this.order_to_print._id });
					window.open(route.href, '_blank');
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		openDialogPrint(item) {
			this.dialogPrint = true;
			this.order_to_print = item;
			this.courier_selected = item.preview_courier ? item.preview_courier : null;
			this.user_selected = item.worker ? item.worker : null;
		},
		printMultiple() {
			let orders_filtered = _.filter(this.getOrders, o => {
				if (this.selectedchecbox.includes(o._id)) {
					return o._id;
				}
			});
			let orders = [];
			for (let order of orders_filtered) {
				orders.push(order._id);
			}
			this.dialogPrintMultiple = true;
			this.orders_to_print = orders.toString();
			this.courier_selected = null;
			this.user_selected = null;
		},

		extension(item) {
			let prova = this.selected.includes(item);
			if (!prova) {
				this.selected.push(item);
			} else {
				let indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}
		},
		isImage(file) {
			const imageExtensions = ['png', 'gif', 'jpeg', 'jpg', 'svg'];
			const extension = file.split('.').pop().toLowerCase();
			return imageExtensions.includes(extension);
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},

		async downloadReviewById() {
			this.errorDownloadReview = '';
			this.loadingDownload = true;
			var result = await this.getOrdersReview({ id_start: this.idStart, id_end: this.idEnd });
			this.loadingDownload = false;

			if (_.size(result.orders) > 0) {
				var textToSave = `RIEPILOGO ORDINI \n\n-------------------------\n`;

				_.forEach(result.orders, order => {
					textToSave += `\nOrdine Id: ${order.OrderID} - Data: ${new Date(order.created_at).toLocaleString()}\n`;
					textToSave += `\n${order.ShippingAddress.Name}\n\n`;

					textToSave += `Prodotti\n`;

					let sku_to_remove = [];

					for (let item of order.Items) {
						if (item.ItemID === 'Virtual') {
							let split_sku = item.SKU.split('-');
							if (split_sku.length > 1) {
								sku_to_remove.push(split_sku[0]);
							}
						}
					}

					if (sku_to_remove.length > 0) {
						order.Items = order.Items.filter(el => {
							return !sku_to_remove.includes(el.SKU);
						});
					}

					for (let item of order.Items) {
						// var name = item.Title.replace(/ *\([^)]*\) */g, "")
						var name = item.Title;
						var split = name.split('-');

						var final;
						if (split.length > 1) {
							var text_1 = split[0].replace(/ *\([^)]*\) */g, '');
							var text_2 = split[1].replace(/ *\([^)]*\) */g, '');
							var replace = text_2.replace(text_1, '');

							final = text_1;
							final += replace == '' || replace == ' ' ? '' : ' -' + replace;
						} else {
							final = name;
						}

						/*
            if(item.kits && item.kits.length > 0){

              textToSave += `-- ${item.Title} - Qtà: ${item.QuantityPurchased}\n`
              _.forEach(item.kits, (kit) =>{
                textToSave += `- ${kit.name} - Qtà: ${kit.qt}\n`
              })

            }else{

             */
						// textToSave += `${item.Title} - Qtà: ${item.QuantityPurchased}\n`
						textToSave += `${final} - Qtà: ${item.QuantityPurchased}\n`;
						//}

						if (_.toString(item.ItemID) == 'Virtual') {
							for (let kit_prod of item.kits) {
								textToSave += `${kit_prod.name}\n`;
							}
						}
					}

					textToSave += `\nMet. Pagamento: ${this.getPayment(order.Checkout.PaymentMethods)} \n`;
					textToSave += `Scatola: ${this.getPackage(order.Packaging)} \n\n`;

					if (order.ShippingService && order.ShippingService.ShippingService.toLowerCase().includes('express')) {
						textToSave += `* Spedizione Express \n\n`;
					}
					if (order.Message) {
						textToSave += `** Sono presenti note nell'ordine \n\n`;
					}
					//textToSave += `Scatola: ${this.getPackageFromColor(order.Color)} \n\n`
					//textToSave += `Corriere: ${(item.package) ? item.package : 'n.d.'} \n\n`

					textToSave += `-------------------------\n`;
				});

				var hiddenElement = document.createElement('a');

				var today = new Date();
				var h = today.getHours();
				var m = today.getMinutes();
				var s = today.getSeconds();

				var now = h + '_' + m + '_' + s;

				hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
				hiddenElement.target = '_blank';
				hiddenElement.download = now + '_riepilogo-ordini.txt';
				hiddenElement.click();
			} else {
				this.errorDownloadReview = 'Gli Id Ordini indicati non risultano corretti per individuare un range';
			}
		},

		async downloadReview() {
			let orders = _.filter(this.getOrders, o => {
				return this.selectedchecbox.includes(o._id);
			});

			if (_.size(orders) > 0) {
				let textToSave = `RIEPILOGO ORDINI \n\n-------------------------\n`;

				_.forEach(orders, order => {
					textToSave += `\nOrdine Id: ${order.OrderID} - Data: ${new Date(order.created_at).toLocaleString()}\n`;
					textToSave += `\n${order.ShippingAddress.Name}\n\n`;

					textToSave += `Prodotti\n`;
					_.forEach(order.Items, item => {
						/*
                    if(item.kits && item.kits.length > 0){

                      textToSave += `-- ${item.Title} - Qtà: ${item.QuantityPurchased}\n`
                      _.forEach(item.kits, (kit) =>{
                        textToSave += `- ${kit.name} - Qtà: ${kit.qt}\n`
                      })

                    }else{

                     */
						textToSave += `${item.Title} - Qtà: ${item.QuantityPurchased}\n`;
						//}
					});
					textToSave += `\nMet. Pagamento: ${this.getPayment(order.Checkout.PaymentMethods)} \n`;
					textToSave += `Scatola: ${this.getPackage(order.Packaging)} \n\n`;
					//textToSave += `Scatola: ${this.getPackageFromColor(order.Color)} \n\n`
					//textToSave += `Corriere: ${(item.package) ? item.package : 'n.d.'} \n\n`

					textToSave += `-------------------------\n`;
				});

				let hiddenElement = document.createElement('a');

				let today = new Date();
				let h = today.getHours();
				let m = today.getMinutes();
				let s = today.getSeconds();

				let now = h + '_' + m + '_' + s;

				hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
				hiddenElement.target = '_blank';
				hiddenElement.download = now + '_riepilogo-ordini.txt';
				hiddenElement.click();
			}
		},
		eliminaFattura(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/eliminaFattura';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.snackbar = true;
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;

						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		annullaOrdineFornitore(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'orders-suppliers/rollback';
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, { order_id: item.OrderID.toString() }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.getDataFromApi();
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.snackbar = true;
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;

						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		contactWhatsapp(number, order) {
			let message = `Salve la contatto per l'ordine #${order}`;
			let url = `https://api.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(message)}`;
			window.open(url, '_blank');
		},
		getImagePayment(img) {
			if (!img) {
				return require(`@/assets/images/Other.svg`);
			}

			try {
				return require(`@/assets/images/${img.value}.svg`);
			} catch (e) {
				return require(`@/assets/images/Other.svg`);
			}
		},
		getImageShip(item) {
			if (item.ShippedTime) {
				return require(`@/assets/images/box_ship.svg`);
			}
			if (item.CancelTime) {
				return require(`@/assets/images/box_cancel.svg`);
			}
			let delivery;
			item.Items.forEach(value => {
				delivery = value.Delivery_max;
			});

			if (delivery) {
				let fromDate = parseInt(new Date().getTime() / 1000);
				let toDate = parseInt(new Date(delivery).getTime() / 1000);
				let timeDiff = (toDate - fromDate) / 3600; // will give difference in hrs
				let box = '';

				if (timeDiff > 6) {
					return require(`@/assets/images/box.svg`);
				}
				if (timeDiff > 1 && timeDiff <= 6) {
					return require(`@/assets/images/box_warning.svg`);
				}
				if (timeDiff <= 1) {
					return require(`@/assets/images/box_late.svg`);
				}
				return require(box);
			} else {
				return require(`@/assets/images/box.svg`);
			}
		},

		getImageMarketplace(img) {
			let logo = '';
			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				case 'Cassa':
					logo = require(`@/assets/images/cassa.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		closeSnackbar() {
			this.setSnackbar(false);
		},
		// async confirm() {
		// 	let payload = this.form;
		// 	try {
		// 		this.preload = true;
		// 		await this.fetchUsers(payload);
		// 	} catch (err) {
		// 		console.log(err);
		// 	}
		// 	this.preload = false;
		// },

		deleteItem(item) {
			this.dialogconfirm = true;

			this.form = item;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			this.preload = true;
			let url = 'auth/delete';

			this.messages = [];

			axios
				.delete(`${this.getUrl}${url}/${this.form._id}`, { headers: { Authorization: `Bearer ${this.getToken}` } })

				.then(() => {
					const index = this.items.indexOf(this.form);
					this.items.splice(index, 1);
					this.deleteitem = '';
					this.snackbar.color = 'success';
					this.snackbar.text = 'Utente Eliminato con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					//confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
					//this.form.permission=pluck(res.data.permissions,id);
					this.preload = false;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							console.log(errors);
							errors.forEach(value => {
								console.log(value.msg);
								this.messages[value.param] = value.msg;
							});
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		getPackage(Packaging) {
			if (Packaging !== undefined) {
				return Packaging.name;
			} else {
				return 'n.d.';
			}
		},
		getPackageFromColor(color) {
			switch (color) {
				case 'grey':
					return 'n.d.';
				case 'red':
					return 1;
				case 'pink':
					return 2;
				case 'purple':
					return 3;
				case 'indigo':
					return 4;
				case 'blue':
					return 5;
				case 'green':
					return 6;
				case undefined:
					return 'n.d.';
				default:
					return 'n.d.';
			}
		},
		getPayment(payment) {
			switch (payment) {
				case 'american express':
				case 'creditcard':
				case 'maestro':
				case 'mastercard':
				case 'paypal':
				case 'visa':
					return 'Pagato';
				case 'bonifico bancario':
					return 'Bonifico';
				case 'cash on delivery (cod)':
				case 'cash on delivery cod':
				case 'cod':
					return 'Contrassegno';
				default:
					return payment;
			}
		},
		getStatusColor(statusId, prep_date) {
			// Fix Madò, in caso di ordine con data preparazione considera come in elaborazione
			if (prep_date !== null && (this.getId === '636f52667160ac8bc2d6df78' || this.getId === '60b2554c7aee6b735869408c')) {
				statusId._id = '60deb7436fee57191fa71150';
			}
			if (statusId && statusId._id) {
				let status = _.find(this.status, { value: statusId._id });
				return status ? status.color : '#FFFFFF';
			} else {
				return '#FFFFFF';
			}
		},
		formatPhoneNumber(phoneNumberString) {
			let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
			let match = cleaned.match(/^(39|)?(\d{3})(\d{3})(\d{4})$/);
			if (match) {
				let intlCode = match[1] ? '+39' : '+39';
				return [intlCode, match[2], match[3], match[4]].join('');
			} else {
				return null;
			}
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
};
</script>

<style></style>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.communication-cards,
.communication-cards tr {
	display: block;
	width: 100%;
}
.communication-cards tr,
.communication-cards tr:hover {
	background: transparent !important;
}
.communication-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.communication-cards tr:first-child td {
	padding-top: 12px !important;
}
.communication-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.communication-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* lista compatta */
.cm-list-row {
	cursor: pointer;
}
.cm-list-row--open,
.cm-list-row--open:hover {
	background: #f3f6fa !important;
}
.cm-expanded,
.cm-expanded:hover {
	background: transparent !important;
}
.cm-nowrap {
	white-space: nowrap;
}
.cm-sub {
	font-size: 12px;
	color: rgba(0, 0, 0, 0.6);
}
.cm-subject-cell {
	max-width: 420px;
}
.cm-subject-line {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
/* card mobile: anteprima su due righe */
.cm-preview {
	font-size: 13px;
	color: rgba(0, 0, 0, 0.7);
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
</style>
